import FloatingWindow from './FloatingWindow.vue';

export default FloatingWindow;
export type { Props as FloatingWindowProps } from './FloatingWindow.vue';
